module.exports = __webpack_public_path__ + "static/media/Duc_Tran.a692a655.svg";